<div class="notificaciones-container">
  <!-- Header -->
  <div class="notificaciones-header">
    <button mat-icon-button class="btn-volver" (click)="volver()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1 class="titulo">NOTIFICACIONES</h1>
    <div class="header-info">
      <span class="contador-badge" *ngIf="getNotificacionesNoLeidas() > 0">
        {{getNotificacionesNoLeidas()}} nuevas
      </span>
    </div>
  </div>

  <!-- Filtros -->
  <div class="filtros-container">
    <button mat-button
            [class.activo]="filtroActivo === 'todas'"
            (click)="cambiarFiltro('todas')">
      Todas ({{notificaciones.length}})
    </button>
    <button mat-button
            [class.activo]="filtroActivo === 'no_leidas'"
            (click)="cambiarFiltro('no_leidas')">
      No leídas ({{getNotificacionesNoLeidas()}})
    </button>
    <button mat-button
            [class.activo]="filtroActivo === 'leidas'"
            (click)="cambiarFiltro('leidas')">
      Leídas ({{notificaciones.length - getNotificacionesNoLeidas()}})
    </button>
  </div>

  <!-- Indicador de carga -->
  <div *ngIf="cargando" class="cargando-container">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <!-- Lista de notificaciones -->
  <div class="notificaciones-lista" *ngIf="!cargando">
    <div *ngFor="let notif of notificacionesPagina"
         class="notificacion-card"
         [ngClass]="getClasesNotificacion(notif)">

      <div class="notificacion-header">
        <mat-icon class="notificacion-icono" [class.icono-alerta]="notif.idTipoAlerta === 2">
          {{getIconoNotificacion(notif)}}
        </mat-icon>
        <div class="notificacion-titulo-container">
          <span class="notificacion-titulo">{{notif.titulo}}</span>
          <span class="notificacion-fecha">{{formatearFecha(notif.fechaGeneracion)}}</span>
        </div>
        <button mat-icon-button class="btn-cerrar-notif" (click)="eliminarNotificacion(notif, $event)">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="notificacion-contenido">
        <p class="notificacion-texto" [innerHTML]="notif.mensaje"></p>
      </div>

      <div class="notificacion-acciones">
        <button mat-button class="btn-eliminar" (click)="eliminarNotificacion(notif, $event)">
          ELIMINAR
        </button>
        <button mat-raised-button
                class="btn-ver"
                [class.alerta-vencida]="notif.idTipoAlerta === 2"
                (click)="verNotificacion(notif)">
          VER
        </button>
      </div>
    </div>

    <!-- Mensaje cuando no hay notificaciones -->
    <div *ngIf="notificacionesFiltradas.length === 0" class="sin-notificaciones">
      <mat-icon>notifications_none</mat-icon>
      <h3>No hay notificaciones</h3>
      <p *ngIf="filtroActivo === 'todas'">No tienes notificaciones en este momento</p>
      <p *ngIf="filtroActivo === 'no_leidas'">No tienes notificaciones sin leer</p>
      <p *ngIf="filtroActivo === 'leidas'">No tienes notificaciones leídas</p>
    </div>

    <!-- Paginación -->
    <mat-paginator
      *ngIf="notificacionesFiltradas.length > 0"
      [length]="notificacionesFiltradas.length"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[5, 10, 25]"
      (page)="onPageChange($event)"
      class="notificaciones-paginator">
    </mat-paginator>
  </div>
</div>
